import {
  CROP_LOADING,
  SET_CROP_ENDPOINT_CALLED,
  SET_CROP_DATA,
  SET_MD5_DATA,
  SET_INITIAL_REGION_DATA,
  SET_ANNOTATION_INDEX,
  SET_IS_ANY_REGION_DELETED,
  CROP_ERROR,
  SET_SELECTED_CROP_REGION,
  CROP_DRAWING,
  SET_CROP_AREA_SIZE,
  SET_CROPPED_IMAGE_URL,
  SET_VERTICAL_CROP_SELECTED,
  SHOW_NEXT_BUTTON_ENABLED_TOOLTIP,
  SET_ROTATION_AMOUNT,
  SET_ROTATION_MODE,
} from '../constants/actionTypes';

/**
 * This is the Redux reducer for the `crop` store key.
 */
export default function update(state = {}, action) {
  if (action.type === CROP_LOADING) {
    return Object.assign({}, state, { loading: action.value });
  } else if (action.type === SET_CROP_DATA) {
    return Object.assign({}, state, { cropData: [...action.value] });
  } else if (action.type === SET_INITIAL_REGION_DATA) {
    return Object.assign({}, state, { initialRegionData: [...action.value] });
  } else if (action.type === SET_MD5_DATA) {
    return Object.assign({}, state, { md5: action.value });
  } else if (action.type === SET_ANNOTATION_INDEX) {
    return Object.assign({}, state, { annotationIndex: action.value });
  } else if (action.type === SET_IS_ANY_REGION_DELETED) {
    return Object.assign({}, state, { isAnyRegionDeleted: action.value });
  } else if (action.type === SET_SELECTED_CROP_REGION) {
    return Object.assign({}, state, {
      cropData: [...action.value.cropData],
      selectedCropRegion: action.value.selectedCropRegion,
    });
  } else if (action.type === CROP_ERROR) {
    return Object.assign({}, state, { errorCode: action.errorCode });
  } else if (action.type === CROP_DRAWING) {
    return Object.assign({}, state, { drawingMode: action.value });
  } else if (action.type === SET_CROP_AREA_SIZE) {
    return Object.assign({}, state, { cropAreaSize: action.value });
  } else if (action.type === SET_CROPPED_IMAGE_URL) {
    return Object.assign({}, state, { croppedImageUrl: action.croppedImageUrl });
  } else if (action.type === SET_VERTICAL_CROP_SELECTED) {
    return Object.assign({}, state, { verticalCropSelected: action.value });
  } else if (action.type === SHOW_NEXT_BUTTON_ENABLED_TOOLTIP) {
    return Object.assign({}, state, {
      cropToolbar: {
        ...state.cropToolbar,
        showNextButtonEnabledTooltip: action.value,
      },
    });
  } else if (action.type === SET_ROTATION_AMOUNT) {
    return Object.assign({}, state, { rotationAmount: action.value });
  } else if (action.type === SET_ROTATION_MODE) {
    return Object.assign({}, state, { rotationMode: action.value });
  } else if (action.type === SET_CROP_ENDPOINT_CALLED) {
    return Object.assign({}, state, { cropEndpointCalled: action.value });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/crop.js